import { FunctionComponent as F, ReactElement, ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import { TooltipPlacement } from "../../../core/types/component";




interface IProps
{
  children: ReactElement;
  lines: ReactNode[];
  tooltipPlacement?: TooltipPlacement;
}


const TextTooltip: F<IProps> = (props: IProps) =>
{
  const el = <>{props.lines.map((l, i) => <div key={"div-" + i}>{l}</div>)}</>;

  return(
    <Tooltip
      placement={props.tooltipPlacement || 'bottom-start'}
      title={el}
      children={props.children}/>);
};

export default TextTooltip;
